/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ElementRef, effect, inject, input } from '@angular/core';
import { DatePipe } from '@angular/common';

import * as noUiSlider from 'nouislider';

import { RegisterComponent } from '../component-lookup';
import { DateRange, StateService } from '../../services/state.service';
import { DateService } from '../../services/date.service';
import { SessionService } from '../../../shared/services/session.service';

@RegisterComponent('DateRangeSelector')
@Component({
  selector: 'app-date-range-selector',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './date-range-selector.component.html',
  styleUrl: './date-range-selector.component.scss'
})
export class DateRangeSelectorComponent {
  private stateService = inject(StateService);
  private dateService = inject(DateService);
  private sessionService = inject(SessionService);
  currentProduct = input<string>('peer-comparison');

  el = inject(ElementRef);
  datepipe: DatePipe = new DatePipe('en-us');

  dateRange: DateRange = {} as DateRange;
  dates: Date[] = [];
  sliderElem: any;
  slider?: any;
  tooltips: any;
  origins: any;

  constructor() {
    effect(() => {
      const institution = this.stateService.institution();
      const datesFetched = this.dateService.datesFetched();
      if (institution.institutionType && datesFetched) {
        if (this.currentProduct() == 'peer-comparison') {
          this.dates = this.dateService.getDates(institution.institutionType);
        }
        else {
          this.dates = this.dateService.getNmdDates(institution.institutionType);
        }
        this.dateRange = this.sessionService.get(`dateRange-${institution.institutionType}`) as DateRange ??
        {
          // globals
          startDate: this.dates[this.dates.length - 13],
          endDate: this.dates[this.dates.length - 1]
        };

        const start = [
          this.dates.findIndex(d => d.getTime() == this.dateRange.startDate.getTime()),
          this.dates.findIndex(d => d.getTime() == this.dateRange.endDate.getTime())
        ];

        const min = 0;
        const max = this.dates.length - 1;
        setTimeout(() => {
          this.initSlider(start, min, max);
        });
      }
    });
  }

  initSlider(start: number[], min: number, max: number) {
    const pips: any = {
      mode: 'steps',
      density: 100,
      filter: function () { return ''; }
    }

    const config: any = {
      keyboardPageMultiplier: 4,
      margin: 1,
      start: start,
      range: {
        'min': min,
        'max': max
      },
      step: 1,
      connect: true,
      behaviour: 'tap-drag',
      tooltips: {
        to: (value: number) => {
          if (this.dates) {
            return this.datepipe.transform(this.dates[Math.round(value)], 'MMM yyyy') ?? '';
          }
          else {
            return '';
          }
        }
      },
      pips: pips
    };

    this.sliderElem = this.el.nativeElement.querySelector('#slider');

    if (this.sliderElem.noUiSlider) {
      this.sliderElem.noUiSlider.destroy();
    }

    noUiSlider.create(this.sliderElem, config);
    this.slider = this.sliderElem.noUiSlider;

    this.tooltips = this.slider.getTooltips();
    this.origins = this.slider.getOrigins();

    this.tooltips.forEach((tooltip: any, index: string | number) => {
      if (tooltip) {
        this.origins[index].appendChild(tooltip);
      }
    });

    this.slider.on('change', (values: any) => {
      this.onChange(values);
    });

    this.slider.on('update', (values: any, handle: any, unencoded: any, tap: any, positions: any, noUiSlider: any) => {
      this.onUpdate(values, handle, unencoded, tap, positions, noUiSlider);
    });

    this.stateService.setDateRange(this.dateRange);
  }

  public onChange(values: number[]) {
    const dateRange = {
      startDate: this.dates[Number(values[0])],
      endDate: this.dates[Number(values[1])]
    }
    this.dateRange = dateRange;
    this.stateService.setDateRange(this.dateRange);
  }

  public onUpdate(values: any, _handle: any, _unencoded: any, _tap: any, positions: any, _noUiSlider: any) {
    const pools: any = [[]];
    const poolPositions: any = [[]];
    const poolValues: any = [[]];
    let atPool = 0;

    if (this.tooltips[0]) {
      pools[0][0] = 0;
      poolPositions[0][0] = positions[0];
      poolValues[0][0] = this.datepipe.transform(this.dates[Math.round(values[0])], 'MMM yyyy') ?? '';
    }

    for (let i = 1; i < positions.length; i++) {
      if (!this.tooltips[i] || (positions[i] - positions[i - 1]) > 12) {
        atPool++;
        pools[atPool] = [];
        poolValues[atPool] = [];
        poolPositions[atPool] = [];
      }

      if (this.tooltips[i]) {
        pools[atPool].push(i);
        poolValues[atPool].push(this.datepipe.transform(this.dates[Math.round(values[i])], 'MMM yyyy') ?? '');
        poolPositions[atPool].push(positions[i]);
      }
    }

    pools.forEach((pool: string | any[], poolIndex: string | number) => {
      const handlesInPool = pool.length;

      for (let j = 0; j < handlesInPool; j++) {
        const handleNumber = pool[j];

        if (j === handlesInPool - 1) {
          let offset = 0;

          poolPositions[poolIndex].forEach(function (value: number) {
            offset += 1000 - value;
          });

          const lastOffset = 1000 - poolPositions[poolIndex][handlesInPool - 1];
          offset = (offset / handlesInPool) - lastOffset;

          // Center this tooltip over the affected handles
          this.tooltips[handleNumber].innerHTML = poolValues[poolIndex].join(' - ');
          this.tooltips[handleNumber].style.display = 'block';

          const width = this.tooltips[handleNumber].offsetWidth;
          if (offset > 0) offset = ((width - 162) / 2) + 45;

          this.tooltips[handleNumber].style['right'] = offset + 'px';
        } else {
          // Hide this tooltip
          this.tooltips[handleNumber].style.display = 'none';
        }
      }
    });
  }
}
